import cx from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { MenuLink } from '.'

import styles from './Links.module.scss'

type Props = {
  title: string
  links: MenuLink[]
  dataCy: string
}

const Links = ({ title, links, dataCy }: Props) => {
  const router = useRouter()
  return (
    <div className={styles.ListContainer}>
      <p className={styles.ListTitle}>{title}</p>
      <ul className={styles.List} data-cy={dataCy}>
        {links.map(({ href, label }) => (
          <li className={cx(styles.ListItem, { [styles.Active]: href === router.asPath })} key={href} tabIndex={0}>
            <Link href={href} passHref>
              <a className={styles.NavLink}>{label}</a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Links
